/**
 * Styled Components - Created by Jesús Apodaca on 31/10/19.
 */
import styled from 'styled-components'

export const Arrow = styled.img`
  height: 50px !important;
  width: 50px !important;
  border-radius: 5px;
  padding: 15px !important;
  text-align: center !important;
  z-index: 3 !important;
  border: 0.2px solid rgba(220,220,220,0.34) !important;
  filter: brightness(10.5);
  background-color: #0000003b !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.07) !important;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CarouselComponent/styledComponents.tsx